import React, { Component } from 'react';
import RedirectCheck from './components/store-redirect/RedirectCheck.js';
import ChangeStore from './components/ChangeStore.js';
import Header from './components/header/Header.js';
import Home from './components/home/Home.js';
import Footer from './components/footer/Footer.js';
import Terms from './components/terms/Terms.js';
import Privacy from './components/terms/Privacy.js';
import './App.css';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { lightGreen700 } from 'material-ui/styles/colors';
import RetailerSearchResults from './components/retailers/RetailerSearchResults.js';
import MerchantHome from './components/merchant/MerchantHome.js';
import MatchWhenAuthorized from './components/auth/MatchWhenAuthorized.js';
import Login from './components/login/Login.js';
import { BrowserRouter, Route } from 'react-router-dom'
import firebase from 'firebase';
import firebaseui from 'firebaseui';
import ReactGA from 'react-ga';
import queryString from 'query-string';

// Initialize material theme settings
const muiTheme = getMuiTheme({
  palette: {
    primary1Color: lightGreen700,
  },
});

const GoogleAnalytics = () => {
    var url = window.location.pathname;
    if (window.location.search){
      url += window.location.search;
    }
    ReactGA.pageview(url);
    return null;
};

class App extends Component {
  constructor(props) {
    super(props);
    this.auth = firebase.auth();
    this.state = {
      retailerMatches: [],
      authenticated: false,
      displayName: "",
      accessToken: "",
      fui: new firebaseui.auth.AuthUI(firebase.auth()),
      merchantSidebarOpen: true,
      retailers: [
        {
          name: "Indo American Convenience Store",
          addressline1: "485 Great Road",
          city: "Acton",
          zipcode: "01720",
          state: "MA",
          offers_delivery: true,
          offers_pickup: true,
          delivery_areas: [
            "01720", "01718", "01754", "01719", 
            "01742", "01460", "01775", "01886"
          ],
          store: "https://ia.pepperly.com",
        }
      ]
    };
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        var displayName = user.displayName;
        var self = this;
        user.getToken().then(function(accessToken) {
          self.setState({
            authenticated: true,
            accessToken: accessToken,
            displayName: displayName
          });
        });
      }else{
        console.log("User is not logged in");
      }
    });
  }

  signInSuccess = (user, redirectLoc) => {
    if (user) {
      var displayName = user.displayName;
      var self = this;
      user.getToken().then(function(accessToken) {
        self.setState({
          authenticated: true,
          displayName: displayName,
          accessToken: accessToken
        });
      });
    }else{
      console.log("User is not logged in");
    }
  }

  isAuthenticated = () => {
    return this.state.authenticated;
  }

  getToken = () => {
    return this.state.accessToken;
  }

  logout = () => {
    this.auth.signOut();
    this.setState({
      authenticated: false,
      displayName: "" 
    });
  }

  handleSearch = (router, zipcode) => {
    this.setState({
      retailerMatches: this.state.retailers,
    });

    // add a new comment
    router.history.push('/stores?zipcode=' + zipcode);
  };

  getRetailers = (zipcode) => {
    if (!zipcode) {
      return {
        deliveryMatches: [],
        deliveryMisses: this.state.retailers,
      };
    }

    var deliveryMatches = [];
    var deliveryMisses = [];
    for (var i=0; i<this.state.retailers.length; i++) {
      if (this.state.retailers[i].delivery_areas.indexOf(zipcode) >= 0) {
        deliveryMatches.push(this.state.retailers[i]);
      }else{
        deliveryMisses.push(this.state.retailers[i]);
      }
    }
    return {
      deliveryMatches: deliveryMatches,
      deliveryMisses: deliveryMisses,
    };
  }

  zipcodeFromQuery = (location) => {
    const query = queryString.parse(location.search)
    if (query.zipcode) {
      return query.zipcode
    }
    return ""
  }

  isMerchant = (location) => {
    if (location && location.pathname) {
      var parts = location.pathname.split('/');
      if (parts.length > 1 && parts[1] === "merchant"){
        return true;
      }
    }
    return false;
  }

  toggleMerchantSidebar = () => {
    this.setState({merchantSidebarOpen: !this.state.merchantSidebarOpen});
  }

  render(props) {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
       <BrowserRouter>
        <div className="App">
          <Route path="/" component={GoogleAnalytics} />
          <Route path="/" render={(props) => 
            <RedirectCheck {...props}>
              <Route path="/" render={(props) => 
                <Header 
                  isAuthenticated={this.isAuthenticated} 
                  logout={this.logout} 
                  isMerchant={this.isMerchant}
                  toggleMenu={this.toggleMerchantSidebar}
                  {...props} />} 
              />
              <Route 
                exact path="/" 
                component={() => <Home searchFunc={this.handleSearch}/>} />
              <Route 
                exact path="/stores" component={({ location }) => 
                <RetailerSearchResults 
                  getRetailersFunc={this.getRetailers} 
                  zipcode={this.zipcodeFromQuery(location)}/> } 
              />
              <Route exact path="/change" component={ChangeStore} />

              <MatchWhenAuthorized 
                path="/merchant" 
                isAuthenticated={this.isAuthenticated} 
                component={() => <MerchantHome 
                  getToken={this.getToken} 
                  toggleSidebar={this.toggleMerchantSidebar}
                  sidebarOpen={this.state.merchantSidebarOpen} />} />
              <Route path="/login" render={(props) => 
                <Login 
                  isAuthenticated={this.isAuthenticated} 
                  signInSuccessFunc={this.signInSuccess} 
                  fui={this.state.fui} {...props} />} 
              />

              <Route exact path="/terms-conditions" component={Terms} />
              <Route exact path="/privacy-policy" component={Privacy} />
              <Footer />
            </RedirectCheck>
          }/>
         </div>
       </BrowserRouter>
      </MuiThemeProvider>
    );
  }
}

App.contextTypes = {
  router: React.PropTypes.object
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js